import { StyleSheet } from 'react-native';

export const GOLD = '#FCD34D';
export const GOLD_DARK = '#F59E0B';
export const MINT = '#6EE7B7';
export const PURPLE_LIGHT = '#C4B5FD';
const SHEET_BG = '#1A1330';
const NODE_BG = '#1F2937';

// theme is intentionally unused here — colors are design-system constants, not theme-derived
export const getDailyRewardModalStyles = () =>
  StyleSheet.create({
    // ── Backdrop ──────────────────────────────────────────────────
    backdrop: {
      flex: 1,
      backgroundColor: 'rgba(8,5,20,0.78)',
      justifyContent: 'flex-end',
    },
    // ── Bottom sheet ──────────────────────────────────────────────
    sheet: {
      marginHorizontal: 10,
      marginBottom: 10,
      borderRadius: 28,
      backgroundColor: SHEET_BG,
      overflow: 'hidden',
    },
    handle: {
      width: 38,
      height: 4,
      borderRadius: 4,
      backgroundColor: 'rgba(255,255,255,0.18)',
      alignSelf: 'center',
      marginTop: 10,
    },
    head: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      paddingHorizontal: 22,
      paddingTop: 16,
      paddingBottom: 4,
    },
    eyebrow: {
      fontSize: 11,
      letterSpacing: 2.2,
      color: GOLD,
      fontWeight: '700',
    },
    titleText: {
      fontSize: 22,
      fontWeight: '800',
      color: '#F7FAFC',
      marginTop: 2,
      letterSpacing: -0.2,
    },
    metaText: {
      fontSize: 13,
      color: '#9CA3AF',
      marginTop: 2,
    },
    closeBtn: {
      width: 34,
      height: 34,
      borderRadius: 17,
      backgroundColor: 'rgba(255,255,255,0.06)',
      alignItems: 'center',
      justifyContent: 'center',
    },
    // ── Hero stage ────────────────────────────────────────────────
    heroStage: {
      height: 186,
      alignItems: 'center',
      justifyContent: 'center',
    },
    coinPileWrap: {
      width: 170,
      height: 170,
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    coinPileImg: {
      width: 155,
      height: 155,
    },
    groundShadow: {
      position: 'absolute',
      bottom: 2,
      width: 130,
      height: 14,
      borderRadius: 65,
      backgroundColor: 'rgba(252,211,77,0.25)',
    },
    sparkWrap: {
      position: 'absolute',
    },
    spark1: { top: '8%', left: '6%' },
    spark2: { top: '12%', right: '4%' },
    spark3: { bottom: '22%', left: '4%' },
    spark4: { bottom: '14%', right: '8%' },
    checkDisc: {
      width: 110,
      height: 110,
      borderRadius: 55,
      backgroundColor: MINT,
      alignItems: 'center',
      justifyContent: 'center',
      shadowColor: MINT,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.5,
      shadowRadius: 20,
      elevation: 12,
    },
    // ── Amount ────────────────────────────────────────────────────
    amountRow: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      justifyContent: 'center',
      gap: 4,
      marginTop: 0,
    },
    amountPlus: { fontSize: 26, fontWeight: '700', color: GOLD, lineHeight: 52 },
    amountNum: {
      fontSize: 60,
      fontWeight: '800',
      color: GOLD,
      letterSpacing: -2,
      lineHeight: 60,
      textShadowColor: 'rgba(252,211,77,0.35)',
      textShadowOffset: { width: 0, height: 4 },
      textShadowRadius: 18,
    },
    amountUnit: {
      fontSize: 12,
      fontWeight: '700',
      letterSpacing: 2,
      color: '#9CA3AF',
      marginBottom: 4,
    },
    // ── Streak chip ───────────────────────────────────────────────
    streakChip: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      paddingVertical: 6,
      paddingHorizontal: 14,
      borderRadius: 99,
      backgroundColor: 'rgba(252,211,77,0.10)',
      marginTop: 8,
      alignSelf: 'center',
    },
    streakText: { fontSize: 13, fontWeight: '600', color: GOLD },
    streakAccent: { fontWeight: '800', color: GOLD },
    // ── Progress path ─────────────────────────────────────────────
    pathContainer: {
      marginHorizontal: 16,
      marginTop: 14,
      borderRadius: 18,
      backgroundColor: 'rgba(255,255,255,0.03)',
      borderWidth: 1,
      borderColor: 'rgba(255,255,255,0.05)',
      paddingHorizontal: 10,
      paddingVertical: 12,
    },
    trackBg: {
      position: 'absolute',
      left: 44,
      right: 44,
      top: 34,
      height: 3,
      borderRadius: 2,
      backgroundColor: 'rgba(255,255,255,0.07)',
      overflow: 'hidden',
    },
    trackFill: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      borderRadius: 2,
    },
    daysRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    dayCol: { alignItems: 'center', gap: 4, flex: 1 },
    dayNode: {
      width: 36,
      height: 36,
      borderRadius: 18,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: NODE_BG,
      borderWidth: 1.5,
      borderColor: 'rgba(255,255,255,0.05)',
    },
    dayNodeDone: { backgroundColor: MINT, borderColor: 'transparent' },
    dayNodeToday: {
      width: 44,
      height: 44,
      borderRadius: 22,
      backgroundColor: GOLD,
      borderColor: 'rgba(252,211,77,0.5)',
      borderWidth: 2,
      shadowColor: GOLD,
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.45,
      shadowRadius: 10,
      elevation: 8,
    },
    dayNodeFinale: { backgroundColor: PURPLE_LIGHT, borderColor: 'rgba(196,181,253,0.4)' },
    dayNodeNum: { fontSize: 13, fontWeight: '700', color: '#6B7280' },
    dayNodeNumToday: { color: '#1A202C', fontWeight: '800', fontSize: 15 },
    dayLabel: { fontSize: 9, color: '#6B7280', fontWeight: '600', letterSpacing: 0.4 },
    dayLabelDone: { color: MINT },
    dayLabelToday: { color: GOLD },
    dayLabelFinale: { color: PURPLE_LIGHT },
    dayAmount: { fontSize: 9, color: '#9CA3AF', fontWeight: '700' },
    dayAmountToday: { color: '#F7FAFC' },
    dayAmountFinale: { color: '#F7FAFC' },
    // ── CTA zone ──────────────────────────────────────────────────
    ctaZone: {
      paddingHorizontal: 20,
      paddingTop: 12,
      paddingBottom: 20,
    },
    ctaBtn: {
      height: 54,
      borderRadius: 16,
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
      gap: 8,
      backgroundColor: GOLD,
      overflow: 'hidden',
      shadowColor: GOLD_DARK,
      shadowOffset: { width: 0, height: 8 },
      shadowOpacity: 0.38,
      shadowRadius: 16,
      elevation: 10,
    },
    ctaBtnPressed: { opacity: 0.88, transform: [{ scale: 0.975 }] },
    ctaBtnDisabled: {
      backgroundColor: 'rgba(255,255,255,0.06)',
      shadowOpacity: 0,
      elevation: 0,
    },
    ctaText: { fontSize: 17, fontWeight: '800', color: '#1A202C', letterSpacing: 0.2, zIndex: 1 },
    ctaTextDisabled: { color: '#6B7280' },
    shimmerStrip: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      width: 80,
      backgroundColor: 'rgba(255,255,255,0.45)',
      zIndex: 0,
    },
    footerStrip: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6,
      marginTop: 8,
    },
    footerText: { fontSize: 13, color: '#9CA3AF' },
    footerBold: { color: '#F7FAFC', fontWeight: '700' },
    // ── Claimed state ─────────────────────────────────────────────
    claimedAmountText: { fontSize: 26, fontWeight: '800', color: '#F7FAFC', textAlign: 'center', marginTop: 10 },
    claimedSubText: { fontSize: 13, color: '#9CA3AF', textAlign: 'center', marginTop: 4 },
    // ── Particle layer (absolute over backdrop) ───────────────────
    particleLayer: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
    particle: {
      position: 'absolute',
      width: 26,
      height: 26,
    },
    confettiPiece: {
      position: 'absolute',
      borderRadius: 2,
    },
  });
